import { Link } from "react-router-dom";

const formats = [
  { name: "Singles stroke play", allow: "95%", icon: "ri-user-line" },
  { name: "Singles match play", allow: "100%", icon: "ri-sword-line" },
  { name: "Fourball stroke play", allow: "85%", icon: "ri-group-line" },
  { name: "Fourball match play", allow: "90%", icon: "ri-team-line" },
  { name: "Foursomes (alternate)", allow: "50% combined", icon: "ri-shuffle-line" },
  { name: "Greensomes", allow: "60% / 40%", icon: "ri-leaf-line" },
  { name: "Scramble (4-person)", allow: "25/20/15/10%", icon: "ri-shake-hands-line" },
  { name: "Stableford", allow: "95%", icon: "ri-bar-chart-line" },
];

export default function FormatsPreview() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="text-xs uppercase tracking-[0.18em] text-primary-700 font-semibold">Format reference</span>
            <h2 className="mt-3 font-heading font-bold text-foreground-950 text-3xl md:text-4xl lg:text-5xl leading-tight">
              <a href="#formats">Every format. Every allowance.</a>
            </h2>
            <p className="mt-4 text-foreground-700 text-base md:text-lg leading-relaxed">
              HANDICALC® supports all the formats your club, society or weekend group is likely to play.
              These are the headline WHS™ allowances — the calculator handles the rest.
            </p>
          </div>
          <Link
            to="/formats"
            className="self-start md:self-end inline-flex items-center gap-2 px-5 py-3 rounded-full bg-background-100 hover:bg-background-200 border border-background-200 text-foreground-900 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
          >
            See all formats <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {formats.map((f) => (
            <article
              key={f.name}
              className="rounded-xl bg-background-100 border border-background-200 p-5 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="w-10 h-10 flex items-center justify-center rounded-md bg-background-50 text-primary-700 border border-background-200">
                  <i className={`${f.icon} text-lg`}></i>
                </span>
                <span className="text-xs font-semibold text-secondary-800 bg-secondary-100 rounded-full px-2.5 py-1 whitespace-nowrap">
                  {f.allow}
                </span>
              </div>
              <h4 className="mt-4 font-heading font-semibold text-foreground-950 text-base">
                <a href="#formats" className="cursor-pointer">{f.name}</a>
              </h4>
              <p className="mt-1 text-xs text-foreground-600">Official WHS™ allowance</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}